import {Outlet, useLocation} from 'react-router-dom';
import Footer from '../components/footer';
import {motion} from 'framer-motion';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../store/redux';
import SuccessModal from '../components/successModal';
import {toggleModal} from '../store/redux/postSuccessModal';
import useGetProfile from '../pages/profile/hooks/useGetProfile';
import {useAuth} from '../context/authContext';
import {useEffect} from 'react';
const AppLayout = () => {
  const {pathname} = useLocation();
  const {show, message, description} = useSelector(
    (state: RootState) => state.successModal,
  );
  const dispatch = useDispatch();

  const handleHide = () => {
    dispatch(
      toggleModal({
        show: false,
        message: '',
        description: '',
      }),
    );
  };

  const {supplierProfile} = useAuth();
  const {refetch} = useGetProfile(supplierProfile?.guid || '', true);

  useEffect(() => {
    refetch();
  }, []);

  return (
    <>
      <div className="container pb-5 mb-5">
        <motion.div
          key={pathname}
          initial={{opacity: 0, x: '100%'}}
          animate={{opacity: 1, x: 0}}
          exit={{opacity: 0, x: '-100%'}}
          transition={{duration: 0.2}}
          className="pb-3 mb-5 w-100 h-100"
        >
          <Outlet />
        </motion.div>
      </div>
      <Footer />

      <SuccessModal
        show={show}
        setShow={handleHide}
        onClick={handleHide}
        title={message}
        description={description}
      />
    </>
  );
};

export default AppLayout;
